/* eslint-disable lines-between-class-members */
import { constants } from '../constants';
import ProductModel from './product';

class OrderModel {
  constructor() {
    this.deliveryMethod = constants.DEFAULT_DELIVERY_METHOD;
    this.paymentMethod = constants.DEFAULT_PAYMENT_METHOD;
    this.location = constants.DEFAULT_LOCATION;
    this.paymentData = undefined;
    this.readyTime = undefined;
    this.userInfo = undefined;
    this.extra = undefined;
    this.coupon = undefined;
  }

  populate({
    products, user, deliveryMethodId, paymentMethodId, locationId,
    paymentData, extra, coupon, readyTime,
  }) {
    this.populateProducts(products);
    this.populateUser(user);
    this.deliveryMethod = deliveryMethodId;
    this.paymentMethod = paymentMethodId;
    this.location = locationId;
    this.paymentData = paymentData;
    this.extra = extra;
    this.readyTime = readyTime;
    this.coupon = coupon;
  }

  populateProducts(products) {
    const results = [];
    if (Array.isArray(products) && products.length > 0) {
      products.forEach((product) => {
        // Use the product model to create the product object
        const productModel = new ProductModel(product);
        if (product.quantity > 0) {
          productModel.quantity = product.quantity;
        }
        results.push(productModel.toOrder(
          productModel.quantity,
        ));
      });
    }
    this.products = results;
  }

  populateUser(user) {
    if (user) {
      this.userInfo = user;
    }
  }
}

export default OrderModel;
